// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1B-K1","search":"Settings_search__1cijl","filter":"Settings_filter__1vt0G"};